<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button
              :type="tableTop == 1 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 1"
              >{{
                `${skillAndCommonTemp ? "技术商务评分" : "商务评分"}${
                  subPackageFlag == "0" ? "" : "(包件：" + packName + ")"
                }`
              }}</el-button
            >
            <!-- <el-button
              :type="tableTop == 2 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 2"
              >供应商信用信息</el-button
            > -->
          </div>
        </div>
        <caigoufengxian
          v-if="tableTop == 2"
          :schemeId="schemeId"
        ></caigoufengxian>

        <el-table
          v-if="tableTop == 1"
          :data="tableData"
          ref="table"
          max-height="510"
          border
          empty-text="该评标项目中，没有有效的供应商投标信息！"
        >
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :show-overflow-tooltip="true"
            :min-width="item.width"
            v-bind="item"
          >
            <template slot="header">
              <template v-if="item.required">
                <span class="star">*</span>{{ item.label }}
              </template>
              <template v-else>{{ item.label }}</template>
            </template>
            <template v-if="item.labelChild && item.labelChild.length > 0">
              <el-table-column
                :show-overflow-tooltip="true"
                v-for="(child, indexch) in item.labelChild"
                :key="indexch"
                align="center"
                v-bind="child"
              >
                <template slot="header">
                  <div
                    :title="child.label"
                    class="el-tooltip tooltip-header"
                    :class="{ 'tooltip-header-flow': child.label.length > 15 }"
                  >
                    {{ child.label }}
                  </div>
                </template>
                <template
                  v-if="child.labelChild && child.labelChild.length > 0"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    v-for="(childTwo, indexchTwo) in child.labelChild"
                    :key="indexchTwo"
                    align="center"
                    min-width="130px"
                    v-bind="childTwo"
                  >
                    <template slot="header">
                      <div
                        :title="childTwo.label"
                        class="el-tooltip tooltip-header"
                        :class="{
                          'tooltip-header-flow': childTwo.label.length > 15
                        }"
                      >
                        {{ childTwo.label }}
                      </div>
                    </template>
                    <template
                      v-if="
                        childTwo.labelChild && childTwo.labelChild.length > 0
                      "
                    >
                      <el-table-column
                        v-for="(childThree, indexch) in childTwo.labelChild"
                        :key="indexch"
                        align="center"
                        v-bind="childThree"
                      >
                        <template slot="header">
                          <div
                            :title="childThree.label"
                            class="el-tooltip tooltip-header"
                            :class="{
                              'tooltip-header-flow':
                                childThree.label.length > 15
                            }"
                          >
                            {{ childThree.label }}
                          </div>
                        </template>
                        <template slot-scope="scope">
                          <el-input
                            v-if="child.type == 'input'"
                            v-limitdecimal.two
                            v-model="scope.row[scope.column.property]"
                            @change="
                              changeScore(
                                $event,
                                scope.column.property,
                                scope.$index
                              )
                            "
                            :min="0"
                            size="mini"
                          ></el-input>
                        </template>
                      </el-table-column>
                    </template>

                    <!--                    <template-->
                    <!--                      v-if="-->
                    <!--                        childTwo.labelChild && childTwo.labelChild.length > 0-->
                    <!--                      "-->
                    <!--                    >-->
                    <!--                      <el-table-column-->
                    <!--                        v-for="(childThree,-->
                    <!--                        indexchThree) in childTwo.labelChild"-->
                    <!--                        :key="indexchThree"-->
                    <!--                        align="center"-->
                    <!--                        v-bind="childThree"-->
                    <!--                      >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                          <el-input-->
                    <!--                            v-if="child.type == 'input'"-->
                    <!--                            v-limitdecimal.two-->
                    <!--                            v-model="scope.row[scope.column.property]"-->
                    <!--                            @change="-->
                    <!--                              changeScore(-->
                    <!--                                $event,-->
                    <!--                                scope.column.property,-->
                    <!--                                scope.$index-->
                    <!--                              )-->
                    <!--                            "-->
                    <!--                            :min="0"-->
                    <!--                            size="mini"-->
                    <!--                          ></el-input>-->
                    <!--                        </template>-->
                    <!--                      </el-table-column>-->
                    <!--                    </template>-->
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
            <template slot-scope="scope">
              <el-input
                maxlength="150"
                show-word-limit
                class="input-short word-limit input-width;"
                v-if="item.type == 'input'"
                v-model="scope.row.scoreDesc"
              ></el-input>
              <el-button
                v-else-if="item.type == 'link'"
                size="mini"
                type="text"
                @click="viewBidFile(scope.row)"
                >查看投标文件</el-button
              >
              <span v-else-if="item.money">{{
                scope.row[item.prop]
                  ? new BigNumber(scope.row[item.prop]).toFormat(2)
                  : ""
              }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-save"
        v-preventReClick
        @click="dealExpertSupScore"
        >保存</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import caigoufengxian from "./components/caigoufengxian";
import {
  qryExpertSupPackQuoteToScoreApi,
  dealExpertSupScoreApi,
  qryExpertSupPackQuoteScoreApi,
  listPurchaseSchemePackageApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "addCommercialGrade",
  components: {
    supplierBidDetails,
    breadcrumbSourcing,
    caigoufengxian
  },
  props: {
    type: {
      type: Number,
      default: 0 // type 0:新增 1：编辑
    },
    packId: {
      type: String,
      default: "" // 包件packId
    },
    skillAndCommon: {
      type: Boolean,
      default: false // false:商务评分  true:商务技术评分
    }
  },
  watch: {
    skillAndCommon(val) {
      this.skillAndCommonTemp = val;
    }
  },
  data() {
    return {
      tableTop: 1,
      BigNumber: BigNumber,
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      skillAndCommonTemp: this.$router.history.current.query.skillAndCommon
        ? this.$router.history.current.query.skillAndCommon
        : this.skillAndCommon,
      breadcrumbData: {
        titname: this.skillAndCommonTemp ? "技术商务评分" : "商务评分"
      },
      tableData: [],
      maxHeight: "",
      headers: [], // 商务表头
      skiiHeaders: [], // 商务技术打分的时候技术表头
      dialogVisible: false,
      formData: {
        supQuoteId: 0, // 供应商报价ID
        supPackQuoteId: "",
        supCode: "" // 供应商编号
      },
      columns: [],
      columnsFree: Object.freeze([
        {
          prop: "id",
          label: "序号",
          fixed: true,
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          fixed: true,
          width: 200
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 170,
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 150,
          type: "link"
        },
        {
          prop: "sscSkillScoreItemBOS",
          label: "技术",
          labelChild: [],
          required: true,
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 90
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 200,
          required: true,
          type: "input"
        }
      ]),
      relationWarningList: [],
      packName: "",
      subPackageFlag: "1" // 是否分包 1分包0不分包
    };
  },
  created() {
    this.maxHeight = window.innerHeight - 320;
    console.log(this.maxHeight);
  },
  mounted() {
    // if (this.$router.history.current.query.skillAndCommon) {
    //   this.skillAndCommonTemp = this.$router.history.current.query.skillAndCommon;
    // }
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS" && n.prop !== "priceAmount"
        );
      } else {
        this.columns = this.columnsFree.filter(n => n.prop !== "priceAmount");
      }
    } else {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS"
        );
      } else {
        this.columns = this.columnsFree.map(n => n);
      }
    }

    this.cumputeData();
    this.getPackData();
    this.getSupPersonnelRelationWarning();
  },
  methods: {
    getSupPersonnelRelationWarning() {
      console.log("getSupPersonnelRelationWarning");
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    cumputeData() {
      if (
        this.$router.history.current.query.type &&
        this.$router.history.current.query.type == "1"
      ) {
        qryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            if (this.skillAndCommonTemp) {
              // this.columns.splice(5, 0, {
              //   prop: "sscSkillScoreItemBOS",
              //   label: "技术",
              //   labelChild: [],
              //   required: true,
              //   align: "center"
              // });
            }
            let labelChild = [];
            let labelSkillChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS = item.sscSupScoreBOS;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS = aItem.sscSupScoreItemBOS;
                aItem.sscScoreItemBOS.forEach(bItem => {
                  if (!bItem.supScore) {
                    bItem.supScore = 0;
                  }
                  item.scoreRule = bItem.scoreRule;
                  item.scoreWeight = bItem.scoreWeight;
                  item.scoreStandard = bItem.scoreStandard;
                  let props =
                    "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId;
                  item[props] = bItem.supScore
                    ? new BigNumber(bItem.supScore).toFormat(2)
                    : bItem.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    aItem.scoreItem +
                    "-" +
                    bItem.scoreRule +
                    "-" +
                    bItem.scoreItemId;
                  item[scoreWeightProps] = bItem.scoreWeight;
                  if (this.skillAndCommonTemp) {
                    if (aItem.scoreItem === "0") {
                      if (
                        labelSkillChild.filter(item => {
                          return (
                            item.prop ==
                            "supScore-" +
                              aItem.scoreItem +
                              "-" +
                              bItem.scoreItemId
                          );
                        }).length == 0
                      ) {
                        labelSkillChild.push({
                          prop: props,
                          label: bItem.scoreRule,
                          width: 150,
                          type: "input",
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + bItem.scoreWeight,
                              width: 150,
                              labelChild: [
                                {
                                  prop: props,
                                  label: bItem.scoreStandard,
                                  width: 150
                                }
                              ]
                              // labelChild: [
                              //   {
                              //     prop: props,
                              //     label: "评分规则内容",
                              //     width: 120
                              //   }
                              // ]
                            }
                          ]
                        });
                      }
                    }
                  }
                  if (aItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 150,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 150,
                            labelChild: [
                              {
                                prop: props,
                                label: bItem.scoreStandard,
                                width: 150
                              }
                            ]
                            // labelChild: [1
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            // if (labelChild.length + labelSkillChild.length < 3) {
            // if (this.skillAndCommonTemp) {
            //   delete this.columns[7].width;
            // } else {
            //   delete this.columns[6].width;
            // }
            // }
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (this.skillAndCommonTemp) {
                this.columns[7].labelChild = labelChild;
                this.columns[6].labelChild = labelSkillChild;
              } else {
                this.columns[6].labelChild = labelChild;
              }
            } else {
              if (this.skillAndCommonTemp) {
                this.columns[8].labelChild = labelChild;
                this.columns[7].labelChild = labelSkillChild;
              } else {
                this.columns[7].labelChild = labelChild;
              }
            }
            this.tableData = res.data.data;
            this.$nextTick(() => {
              // this.$refs.table.doLayout();
            });
          }
        });
      } else {
        qryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            // if (this.skillAndCommonTemp) {
            // this.columns.splice(5, 0, {
            //   prop: "sscSkillScoreItemBOS",
            //   label: "技术",
            //   labelChild: [],
            //   required: true,
            //   align: "center"
            // });
            // }
            let labelChild = [];
            let labelSkillChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (!sscScoreItemBO.supScore) {
                    sscScoreItemBO.supScore = "";
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props =
                    "supScore-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore
                    ? new BigNumber(sscScoreItemBO.supScore).toFormat(2)
                    : sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] = sscScoreItemBO.scoreWeight;
                  if (this.skillAndCommonTemp) {
                    if (sscScoreBOItem.scoreItem === "0") {
                      if (
                        labelSkillChild.filter(item => {
                          return (
                            item.prop ==
                            "supScore-" +
                              sscScoreBOItem.scoreItem +
                              "-" +
                              sscScoreItemBO.scoreItemId
                          );
                        }).length == 0
                      ) {
                        labelSkillChild.push({
                          prop: props,
                          label: sscScoreItemBO.scoreRule,
                          width: 150,
                          type: "input",
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + sscScoreItemBO.scoreWeight,
                              width: 150,
                              labelChild: [
                                {
                                  prop: props,
                                  label: sscScoreItemBO.scoreStandard,
                                  width: 150
                                }
                              ]
                              // labelChild: [
                              //   {
                              //     prop: props,
                              //     label: "评分规则内容",
                              //     width: 120
                              //   }
                              // ]
                            }
                          ]
                        });
                      }
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 150,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 150,
                            labelChild: [
                              {
                                prop: props,
                                label: sscScoreItemBO.scoreStandard,
                                width: 150
                              }
                            ]
                            // labelChild: [
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (this.skillAndCommonTemp) {
                this.columns[7].labelChild = labelChild;
                this.columns[6].labelChild = labelSkillChild;
              } else {
                this.columns[6].labelChild = labelChild;
              }
            } else {
              if (this.skillAndCommonTemp) {
                this.columns[8].labelChild = labelChild;
                this.columns[7].labelChild = labelSkillChild;
              } else {
                this.columns[7].labelChild = labelChild;
              }
            }
            this.tableData = res.data.data;
            console.log(this.columns, "columns");
            this.$nextTick(() => {
              // this.$refs.table.doLayout();
            });
          }
        });
      }
    },
    getPackData() {
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.packId
          ? this.packId
          : this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
      });
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    // 改变分数计算汇总得分
    changeScore(value, prop, index) {
      let total = 0;
      let flag = true;
      let message = "";
      try {
        for (let key in this.tableData[index]) {
          if (key.includes("supScore-")) {
            // 不能大于权重大小
            for (let keyWeight in this.tableData[index]) {
              if (keyWeight.includes("maxScoreWeight-")) {
                let scoreItem = key.substring(9, 10);
                let scoreWeightItem = keyWeight.substring(15, 16);
                let scoreItemId = key.substring(11);
                let scoreWeightItemId = keyWeight.substring(
                  keyWeight.lastIndexOf("-") + 1
                );
                let scoreRule = keyWeight.substring(
                  17,
                  keyWeight.lastIndexOf("-")
                );
                if (
                  scoreItem === scoreWeightItem &&
                  scoreItemId === scoreWeightItemId
                ) {
                  if (
                    Number(this.tableData[index][key]) >
                    Number(this.tableData[index][keyWeight])
                  ) {
                    flag = false;
                    this.tableData[index][prop] = 0;
                    message =
                      "第" +
                      (index + 1) +
                      "行的" +
                      scoreRule +
                      "的得分不允许大于细则权重" +
                      this.tableData[index][keyWeight] +
                      "分，谢谢您的配合！";
                    throw Error();
                  }
                }
              }
            }
            //total += Number(this.tableData[index][key]);
            total = window.$computeUtil.getPlus(
              total,
              this.tableData[index][key] || "0"
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
      if (total) {
        //total = Number(total).toFixed(2);
        total = new BigNumber(total).toFormat(2);
      }
      if (flag) {
        this.$set(this.tableData[index], "supScore", total);
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 保存
    dealExpertSupScore() {
      if (this.tableData.length === 0) {
        this.$message({
          message: `供应商已全部淘汰，请联系采购承办人进行流标操作`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let sscExpertSupScoreBOS = [];
        let flag = true;
        let message = "";
        if (this.skillAndCommonTemp) {
          try {
            this.tableData.forEach((item, index) => {
              let tempSscExpertSupScoreBOS = []; // 技术商务评分的时候临时存的数据
              let scoreItemIdArr = [];
              // if (!item.scoreDesc) {
              //   flag = false;
              //   message = "第" + (index + 1) + "行的打分说明不能为空";
              //   throw Error();
              // }
              for (let key in item) {
                if (key.includes("supScore-")) {
                  // 不能大于权重大小
                  for (let keyWeight in item) {
                    if (keyWeight.includes("maxScoreWeight-")) {
                      let scoreItem = key.substring(9, 10);
                      let scoreWeightItem = keyWeight.substring(15, 16);
                      let scoreItemId = key.substring(11);
                      let scoreWeightItemId = keyWeight.substring(
                        keyWeight.lastIndexOf("-") + 1
                      );
                      let scoreRule = keyWeight.substring(
                        17,
                        keyWeight.lastIndexOf("-")
                      );
                      if (
                        scoreItem === scoreWeightItem &&
                        scoreItemId === scoreWeightItemId
                      ) {
                        if (
                          Number(this.tableData[index][key]) >
                          Number(this.tableData[index][keyWeight])
                        ) {
                          flag = false;
                          message =
                            "第" +
                            (index + 1) +
                            "行的" +
                            scoreRule +
                            "的得分不允许大于细则权重" +
                            this.tableData[index][keyWeight] +
                            "分，谢谢您的配合！";
                          throw Error();
                        }
                      }
                    }
                  }
                  // 得分不能为空
                  if (
                    !Number(this.tableData[index][key]) &&
                    this.tableData[index][key] !== 0 &&
                    this.tableData[index][key] !== "0.00"
                  ) {
                    flag = false;
                    message = "第" + (index + 1) + "行的评分不能为空";
                    throw Error();
                  }
                  let obj = {};
                  obj.supCode = item.supCode;
                  obj.supName = item.supName;
                  obj.supScore = item.supScore;
                  obj.scoreDesc = item.scoreDesc;
                  let sscSupScoreItemBOS = [];
                  obj.scoreItem = key.substring(9, 10);
                  if (!scoreItemIdArr.includes(key)) {
                    scoreItemIdArr.push(key);
                    let sscScoreObj = {};
                    sscScoreObj.scoreItemId = key.substring(11);
                    sscScoreObj.supScore = this.tableData[index][key];
                    sscSupScoreItemBOS.push(sscScoreObj);
                  }
                  obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
                  tempSscExpertSupScoreBOS.push(obj);
                }
                if (
                  !item.scoreDesc ||
                  (key == "scoreDesc" && !this.tableData[index][key])
                ) {
                  flag = false;
                  message = "第" + (index + 1) + "行的打分说明不能为空";
                  throw Error();
                }
              }
              let skillSscSupScoreItemBOS = []; // 技术
              let commonSscSupScoreItemBOS = []; // 商务
              tempSscExpertSupScoreBOS.forEach(temp => {
                if (temp.scoreItem == "0") {
                  // 技术
                  temp.sscSupScoreItemBOS.forEach(sscItem => {
                    skillSscSupScoreItemBOS.push(sscItem);
                  });
                } else {
                  // 商务
                  temp.sscSupScoreItemBOS.forEach(sscItem => {
                    commonSscSupScoreItemBOS.push(sscItem);
                  });
                }
              });
              if (skillSscSupScoreItemBOS.length) {
                sscExpertSupScoreBOS.push({
                  scoreItem: "0",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: skillSscSupScoreItemBOS
                });
              }
              if (commonSscSupScoreItemBOS.length) {
                sscExpertSupScoreBOS.push({
                  scoreItem: "1",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: commonSscSupScoreItemBOS
                });
              }
            });
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            this.tableData.forEach((item, index) => {
              let scoreItemIdArr = [];
              let obj = {};
              obj.supCode = item.supCode;
              obj.supName = item.supName;
              obj.supScore = item.supScore;
              obj.scoreDesc = item.scoreDesc;
              obj.scoreItem = "1";
              let sscSupScoreItemBOS = [];
              // if (!item.scoreDesc) {
              //   flag = false;
              //   message = "第" + (index + 1) + "行的打分说明不能为空";
              //   throw Error();
              // }
              for (let key in item) {
                if (key.includes("supScore-")) {
                  // 不能大于权重大小
                  for (let keyWeight in item) {
                    if (keyWeight.includes("maxScoreWeight-")) {
                      let scoreItem = key.substring(9, 10);
                      let scoreWeightItem = keyWeight.substring(15, 16);
                      let scoreItemId = key.substring(11);
                      let scoreWeightItemId = keyWeight.substring(
                        keyWeight.lastIndexOf("-") + 1
                      );
                      let scoreRule = keyWeight.substring(
                        17,
                        keyWeight.lastIndexOf("-")
                      );
                      if (
                        scoreItem === scoreWeightItem &&
                        scoreItemId === scoreWeightItemId
                      ) {
                        if (
                          Number(this.tableData[index][key]) >
                          Number(this.tableData[index][keyWeight])
                        ) {
                          flag = false;
                          message =
                            "第" +
                            (index + 1) +
                            "行的" +
                            scoreRule +
                            "的得分不允许大于细则权重" +
                            this.tableData[index][keyWeight] +
                            "分，谢谢您的配合！";
                          throw Error();
                        }
                      }
                    }
                  }
                  if (
                    !Number(this.tableData[index][key]) &&
                    this.tableData[index][key] !== 0 &&
                    this.tableData[index][key] !== "0.00"
                  ) {
                    flag = false;
                    message = "第" + (index + 1) + "行的评分不能为空";
                    throw Error();
                  }
                  if (!scoreItemIdArr.includes(key)) {
                    scoreItemIdArr.push(key);
                    let sscScoreObj = {};
                    sscScoreObj.scoreItemId = key.substring(11);
                    sscScoreObj.supScore = this.tableData[index][key];
                    sscSupScoreItemBOS.push(sscScoreObj);
                  }
                }
                if (
                  !item.scoreDesc ||
                  (key == "scoreDesc" && !this.tableData[index][key])
                ) {
                  flag = false;
                  message = "第" + (index + 1) + "行的打分说明不能为空";
                  throw Error();
                }
              }
              obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
              sscExpertSupScoreBOS.push(obj);
            });
          } catch (e) {
            console.log(e);
          }
        }
        console.log(sscExpertSupScoreBOS);
        if (flag) {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: this.packId
              ? this.packId
              : this.$router.history.current.query.packId,
            packName: this.packName,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            expertName: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .expertName,
            purStep: this.$router.history.current.query.menuKey,
            scoreType: this.skillAndCommonTemp ? "2" : "1",
            sscExpertSupScoreBOS: sscExpertSupScoreBOS
          };
          dealExpertSupScoreApi(param).then(res => {
            this.$message({
              message: "评分表保存成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.$router.push({
              name: "commercialGradeList",
              query: {
                backPageSkillAndCommon: this.skillAndCommonTemp ? "1" : "2", // 商务技术：1 商务：2
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                evaPurStep: this.$router.history.current.query.evaPurStep,
                active: this.$route.query.active
              }
            });
          });
        } else {
          this.$message({
            message: message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
.priamryColor {
  color: #0089ef;
  cursor: pointer;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
/deep/ .el-table th > .cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
</style>
<style lang="scss">
.iframeMain-box .dic-ccui-app-main {
  padding-bottom: 1px !important;
}
</style>
